import * as React from "react";
import { forwardRef } from "react";
const SvgTickSelector = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 32, height: 32, rx: 16, fill: "#31B073" }), /* @__PURE__ */ React.createElement("path", { d: "M13.8784 21.1859L9.63574 16.9433L11.5224 15.0566L13.8784 17.4192L20.477 10.814L22.3637 12.7006L13.8784 21.1859Z", fill: "white" }));
const ForwardRef = forwardRef(SvgTickSelector);
export { ForwardRef as ReactComponent };
